<template>
    <div>
        <a-button class="top_btn" type="primary" @click="()=>{  visibleForm = true; titleForm='添加服务器' }" v-has="'btn_add'" > 添加服务器
        </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"  >
          <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)"
                   :checked="text==1?true:false" :disabled="!$_has('btn_status')"/>
      </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; titleForm='修改角色'; editId=text.id ; }" v-has="'btn_edit'">编辑 <a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
              <ServerForm :visible="visibleForm" :title="titleForm" :editId="editId"
                        @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import ServerForm from "./components/serverForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            width: "10%",
            ellipsis: true,
            key: "id"
        },
        {
            title: "服务器名称",
            dataIndex: "name",
            width: "15%",
            ellipsis: true,
            key: "name"
        },
        {
            title: "ip",
            dataIndex: "ip",
            ellipsis: true,
            key: "ip"
        },
        {
            title: "网站数量",
            dataIndex: "site_num",
            ellipsis: true,
            key: "site_num"
        },
        {
            title: "注册地址",
            dataIndex: "registered_address",
            ellipsis: true,
            key: "registered_address"
        },
        {
            title: "状态",
            key: "status",
            width: "10%",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'AdministratorList',
        data() {
            return {
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/UserBackground/ServerManagement"; //设置左侧导航2-2 active
        },
        components: {ServerForm},
        methods: {
            getList() {
                API.serverManagement.GET_LIST().then(res => {
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.serverManagement.CHANG_STATUS, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            confirm(row) {
                removeById(API.serverManagement.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
